// extracted by mini-css-extract-plugin
export default {"loginPage":"LoginPage_loginPage__kYiFr","mainContent":"LoginPage_mainContent__KZWhp"};